export const SHARE_TYPE = 'share';
export const SMART_TYPE = 'smart';
export const SHARE_FILE_TYPE = 'shared_with_me';
export const REQUEST_ACCESS_TYPE = 'request';
export const APPROVED_ACCESS_TYPE = 'approved';
export const APPROVED_ACCESS_TYPE_SERVER = ['read'];
export const PENDING_ACCESS_TYPE = 'pending';
export const BLOCKED_ACCESS_TYPE = 'blocked';
